/**
 * Açık bir sekme, yeni bir sürümün yayınlandığını nereden bilecek — DST-00078.
 *
 * 20.08'de verilen söz: "açık sekmeye «yeni sürüm var, yenileyin» diyen bir
 * uyarı yok". Uygulama bir kez yüklenip günlerce açık kalıyor; aradaki her
 * dağıtımda sekme eski kodla çalışmaya devam ediyor. Kimse söylemediği için
 * düzeltilmiş bir hatayı hâlâ görüyor, ya da bir ekranın dosyası sunucudan
 * silindiği için «Sayfa yüklenemedi» ile karşılaşıyor.
 *
 * SÜRÜMÜN KAYNAĞI `/release-notes.json`. Dosya her web imajına, o imajın
 * paketiyle birlikte gömülüyor; yani sekme açılırken okunan en yeni sürüm,
 * sekmenin ÇALIŞTIRDIĞI sürüm. Sonra aynı dosya yeniden okunup başka bir sürüm
 * görülürse arada bir dağıtım olmuş demektir. Ayrı bir uç ya da derleme anında
 * gömülü bir sabit gerekmiyor — ikisi de ikinci bir gerçek olurdu.
 *
 * Geliştirmede dosya yok: iki taraf da `null` ve uyarı hiç görünmüyor.
 */

/** Dosyanın en üstündeki sürüm — yoksa ya da biçim bozuksa `null`. */
export function enYeniSurum(govde: unknown): string | null {
  const releases = (govde as { releases?: unknown } | null)?.releases;
  if (!Array.isArray(releases) || releases.length === 0) return null;
  const ilk: unknown = releases[0];
  const surum = (ilk as { version?: unknown } | null)?.version;
  return typeof surum === 'string' && surum.length > 0 ? surum : null;
}

/**
 * Sekmenin yüklendiği sürümden farklı bir sürüm yayında mı.
 *
 * İki taraf da BİLİNMİYORSA hayır. Okunamayan bir dosya "yeni sürüm var"
 * demek değil; yanlış bir uyarı, gerçeğinin de okunmamasını öğretir.
 */
export function yeniSurumYayinda(
  yuklenen: string | null | undefined,
  simdiki: string | null | undefined,
): boolean {
  return Boolean(yuklenen) && Boolean(simdiki) && yuklenen !== simdiki;
}

/** Ne sıklıkla bakılıyor. Dosya `no-cache` ile isteniyor: değişmediyse 304. */
export const YENI_SURUM_ARALIGI_MS = 5 * 60_000;
